import { pfmFeatureConfig as base } from './base';
import { pfmFeatureConfig as HU } from './HU';

export const featureConfigMap = {
    base,
    HU,
};
